module.exports = __webpack_public_path__ + "img/Gallery_3_01.af9021ca.jpeg";